<template>
    <div class="pages">
        <div class="header">
            <div class="header-title">
                <p>{{ pageTitle.cn }}</p><p>{{ pageTitle.en }}</p>
            </div>
        </div>
        <div class="container">
            <p class="hasInput">必填项</p>
            <van-form @submit="onSubmit">
                <van-cell-group inset>
                    <van-field
                        v-model="name"
                        name="name"
                        placeholder="姓名/主体名称"
                        :rules="[{ required: true, message: '请填写姓名/主体名称' }]"
                    />
                    <van-field
                        v-model="village"
                        name="village"
                        placeholder="详细地址"
                        :rules="[{ required: true, message: '请填写详细地址' }]"
                    />
                    <van-field
                        v-model="area"
                        name="area"
                        placeholder="投保面积"
                        :rules="[{ required: true, message: '请填写投保面积' }]"
                    />
                    <van-field
                        v-model="insureType"
                        is-link
                        readonly
                        name="insureType"
                        placeholder="投保种类"
                        @click="showPicker1 = true"
                    />
                    <van-popup v-model:show="showPicker1" position="bottom">
                        <van-picker
                            :columns="['小麦','玉米','大蒜','棉花','留兰香','蔬菜']"
                            @confirm="onConfirm"
                            @cancel="showPicker1 = false"
                        />
                    </van-popup>
                    <van-field
                        v-model="insureCompany"
                        is-link
                        readonly
                        name="insureCompany"
                        placeholder="投保公司"
                        @click="showPicker2 = true"
                    />
                    <van-popup v-model:show="showPicker2" position="bottom">
                        <van-picker
                            :columns="['中国人民财产保险股份有限公司商河支公司','中国人寿财产保险有限公司济南市商河支公司']"
                            @confirm="onConfirmInsure"
                            @cancel="showPicker2 = false"
                        />
                    </van-popup>
                    <van-field
                        v-model="phone"
                        name="phone"
                        placeholder="联系电话"
                        :rules="[{ required: true, message: '请填写联系电话' }]"
                    />
                </van-cell-group>
                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">
                        提交
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>

<script>
import { Form, Field, CellGroup, Button, Picker,Popup } from 'vant'
import 'vant/es/button/style'
import 'vant/es/form/style'
import 'vant/es/field/style'
import 'vant/es/cell-group/style'
import 'vant/es/picker/style'
import 'vant/es/popup/style'
import { ref } from 'vue'
import {addUserInsureApi} from "../../../api/townCenter";
import {notification} from "ant-design-vue";
export default {
    name: "toubao",
    setup() {
        const pageTitle = {
            cn: '我要投保',
            en: 'INSURANCE APPLICATION'
        }
        const name = ref('')
        const area = ref('')
        const village = ref('')
        const phone = ref('')
        const insures = {
            '小麦': 1,
            '玉米': 2,
            '大蒜': 3,
            '棉花': 4,
            '留兰香': 5,
            '蔬菜': 6,
        }
        const company = {
            '中国人民财产保险股份有限公司商河支公司': 1,
            '中国人寿财产保险有限公司济南市商河支公司': 2,
        }

        const showPicker1 = ref(false)
        const showPicker2 = ref(false)
        const insureType = ref('')
        const onConfirm = (value) => {
            insureType.value = value
            showPicker1.value = false
        }
        const insureCompany = ref('')
        const onConfirmInsure = (value) => {
            insureCompany.value = value
            showPicker2.value = false
        }
        // 选择乡镇结束
        const onSubmit = (values) => {
            // console.log('submit', values)
            // console.log(insures[values.insureType])
            // console.log(company[values.insureCompany])
            const params = {
                name: values.name,
                village: values.village,
                area: values.area,
                insureType: insures[values.insureType],
                insureCompany: company[values.insureCompany],
                phone: values.phone
            }
            addUserInsureApi(params).then(res => {
                if (res) {
                    notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                    setTimeout(() => {
                        location.reload()
                    }, 2000)
                }
            })
        }
        return {
            pageTitle,
            name,
            area,
            phone,
            village,
            insureType,
            insureCompany,
            onConfirm,
            onConfirmInsure,
            showPicker1,
            showPicker2,
            onSubmit,
        }
    },
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Button.name]: Button,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
    }
}
</script>

<style scoped lang="stylus">
.pages {
    width 100%
    height 100%
    background-color #F6F7FB
    .header {
        width 100%
        height 170px
        background-image url("../../../assets/img/town_home_bg.png")
        background-repeat no-repeat
        background-size 100% 100%
        font-size 22px
        color #FFF
        display flex
        align-items center
        justify-content center
        .header-title {
            width 100%
            text-align center
        }
        .header-title p:last-child {
            font-size 12px
        }
    }
    .container {
        width 100%
        padding 16px 0
        background-color #F6F7FB
        .hasInput {
            font-size 14px
            color #1A1A1A
            margin-bottom 10px
            margin-left 20px
        }
        .hasInput:before {
            content '* '
            color #F05A24
        }
    }
}
</style>
